import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

//import { Box,Container,Row,Column,FooterLink,Heading,Address,SocialMediaBlock,ContentDiv } from "./pages/ContentStyles";
import { ContentDiv } from "./pages/ContentStyles";

//import 'bootstrap/dist/css/bootstrap.min.css';

import Menu from "./pages/Menu";
import Footer from './pages/Footer';

import Home from "./pages/Home";

import HomeNar from "./pages/HomeNar";

//import Info     from "./pages/Info";

import Signup from "./pages/Signup";

import OrderDetails from "./pages/Admin/OrderDetails";

import CookieConsent from "./pages/CookieConcent"

import Login from "./pages/common/Login";
import MyPage from "./pages/common/MyPage";
import NoPage from "./pages/common/NoPage";
import Contact from "./pages/common/Contact";
import Invoices from "./pages/common/Invoices";
import Terminate from "./pages/common/Terminate";
import Subscriptions from "./pages/common/Subscriptions";
import InstanceVerify from "./pages/common/InstanceVerify";
import ChangePassword from "./pages/common/ChangePassword";
import RequestNewPassword from "./pages/common/RequestNewPassword";
import RequestNewPasswordSet from "./pages/common/RequestNewPasswordSet";

import Reports from "./pages/Admin/Reports";
import SellReport from "./pages/Admin/SellReport";
import SellToInvoiceReport from "./pages/Admin/SellToInvoiceReport";

import Orders from "./pages/Admin/Orders";
import QR from "./pages/QR";

import Products from "./pages/Admin/Products";
import ProductGroups from "./pages/Admin/ProductGroups";

import Shops from "./pages/Admin/Shops";
import ShopDetails from "./pages/Admin/Shop";

import Customers from "./pages/Admin/Customers";
import CustomerDetails from "./pages/Admin/Customer";
import Project from "./pages/Admin/Project";
import Example from "./pages/Example";
import Instances from "./pages/Admin/Instances";
import PricingPage from "./pages/PricePage";

import Upload from './pages/Admin/upload';
import "./pages/Global.scss";
import FaqPage from "./pages/FaqPage";
import GalleryPage from "./pages/GallaryPage";
import StartStore from "./pages/StartStore";
import { HelmetProvider } from "react-helmet-async";
import IOTCore from "./pages/Admin/IOTCore";
import ControlPanel from "./pages/Admin/ControlPanel";

import { Branding } from './services/misc';

import useBackend, { XLogOff, IsLoggedIn } from "./services/useBackend";

export default function App() {
  // if (window.location.origin == "https://www.xn--nrbutik-5wa.se") {
  //   window.document.title = "Närbutik";
  // } else {
  //   window.document.title = "Nookshop";
  // }

  var { loggedIn, isSuperUser, userName } = IsLoggedIn();

  return (
    <>
      <BrowserRouter>
        <div className="app-shell">
          <ContentDiv className="app-content">
            <Routes>
{/*               {window.location.origin == "https://www.xn--nrbutik-5wa.se" ?
                <Route index element={<Home />} />
                :
                <Route index element={<Home />} />
              } */}

              {loggedIn ? <Route index element={<ControlPanel />} /> : <Route index element={<Home />} /> }

              <Route path="ControlPanel" element={<ControlPanel />} />

              <Route path="signup" element={<Signup />} />
              <Route path="instance/Invoices" element={<Invoices />} />
              <Route path="instance/terminate" element={<Terminate />} />
              <Route path="instance/verify/:GUID" element={<InstanceVerify />} />
              <Route path="instance/Subscriptions" element={<Subscriptions />} />

              <Route path="Password/Request/new" element={<RequestNewPassword />} />
              <Route path="Password/Request/set/:GUID" element={<RequestNewPasswordSet />} />
              <Route path="Password/change" element={<ChangePassword />} />

              <Route path="contact" element={<Contact />} />
              <Route path="login" element={<Login />} />
              <Route path="MyPage" element={<MyPage />} />

              <Route path="Orders" element={<Orders />} />
              <Route path="orders/:OrderGUID" element={<OrderDetails />} />

              <Route path="Products" element={<Products />} />
              <Route path="ProductGroups" element={<ProductGroups />} />

              <Route path="Shops" element={<Shops />} />
              <Route path="Shop/:ShopGUID" element={<ShopDetails />} />

              <Route path="Customers" element={<Customers />} />
              <Route path="Customer/:CustomerGUID" element={<CustomerDetails />} />

              <Route path="QR" element={<QR />} />

              <Route path="Reports" element={<Reports />} />
              <Route path="SellReport" element={<SellReport />} />
              <Route path="SellToInvoiceReport" element={<SellToInvoiceReport />} />

              <Route path="Project" element={<Project />} />
              <Route path="Instances" element={<Instances />} />
              <Route path="Example" element={<Example />} />
              <Route path="Uploadx" element={<Upload />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/galleri" element={<GalleryPage />} />


              <Route path="start" element={<StartStore />} />
              <Route path="PricingPage" element={<PricingPage />} />
            
              <Route path="iotcore" element={<IOTCore />} />
              
              <Route path="*" element={<NoPage />} />
            </Routes>
          </ContentDiv>
          <Footer />
          <CookieConsent />
        </div>
      </BrowserRouter>


    </>
  );
}

//ReactDOM.render(<App />, document.getElementById("root"));
const root = ReactDOM.createRoot(document.getElementById("main"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

const top = ReactDOM.createRoot(document.getElementById("top"));
top.render(
  <React.StrictMode>
    <Menu></Menu>
  </React.StrictMode>
);